import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-camera",
  "use": "icon-camera-usage",
  "viewBox": "0 0 49 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 40\" id=\"icon-camera\">\n  <title>camera</title>\n  <path d=\"M24.79,11.43A10.68,10.68,0,0,0,14,22a10.77,10.77,0,0,0,21.53,0A10.68,10.68,0,0,0,24.79,11.43Zm0,17.14A6.57,6.57,0,1,1,31.56,22,6.68,6.68,0,0,1,24.79,28.57ZM46.62,8.1a8.08,8.08,0,0,0-5.75-2.38H36L33.86,1.63A3,3,0,0,0,31.19,0h-14a3,3,0,0,0-2.67,1.63L12.46,5.71H7.84A7.85,7.85,0,0,0,0,13.56V30A10,10,0,0,0,10,40H39A10,10,0,0,0,49,30V13.85A8.08,8.08,0,0,0,46.62,8.1ZM45,30a6,6,0,0,1-6,6H10a6,6,0,0,1-6-6V13.56A3.85,3.85,0,0,1,7.84,9.71h5.23a3,3,0,0,0,2.67-1.63L17.83,4H30.58l2.09,4.08a3,3,0,0,0,2.67,1.63h5.53A4.14,4.14,0,0,1,45,13.85Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/camera.svg
// module id = 108
// module chunks = 0 1 2